<script setup lang="ts">
defineProps<{
  title: string
  sub?: string
}>()
</script>

<template>
  <header class="page-header">
    <div class="page-header-text">
      <h1>{{ title }}</h1>
      <div v-if="sub" class="page-header-sub">{{ sub }}</div>
    </div>
    <div v-if="$slots.actions" class="page-header-actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<style scoped>
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--sp-4);
  flex-wrap: wrap;
  padding: var(--sp-4) 0 var(--sp-5);
}
.page-header-text { min-width: 0; flex: 1 1 auto; }
.page-header h1 {
  margin: 0;
  font-size: var(--fs-2xl);
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -0.01em;
}
.page-header-sub {
  margin-top: var(--sp-1);
  font-size: var(--fs-13);
  color: var(--muted);
}
.page-header-actions {
  display: flex;
  gap: var(--sp-2);
  flex-wrap: wrap;
}
@media (max-width: 640px) {
  .page-header-actions { width: 100%; }
}
</style>
